import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useRouter } from 'next/router';

import * as actionTypes from "@redux/actionTypes";

const LeftSection = () => {
    const router = useRouter();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.setUserDetails.user)
    const coinInputNumberDefault = useSelector((state) => state.coinName.coinInputNumberDefault);

    const buyTcHandler = () => {
        dispatch({
            type: actionTypes.BUY_TC,
            payload: true,
        });
        dispatch({
            type: actionTypes.COIN_BALANCE_NUMBER,
            payload: coinInputNumberDefault,
        });
    };

    const buyLpHandler = () => {
        router.push('/buy-gamepass');
    }

    return (
        <div className='h-full flex gap-[10px] p-[32px] flex-col justify-between items-center' >
            <div className='flex flex-col items-start gap-[16px]'>
                <p className='text-[#FAFAFA] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px] opacity-50'>Your Time Credits & XP:</p>
                <div className='flex items-center gap-[8px]'>
                    <p className='text-[#FFF] text-[42px] not-italic font-semibold leading-[42px] tracking-[-2.52px]'>{user?.time_credit} TC</p>
                </div>
                <div className='flex items-center gap-[8px]'>
                    <p className='text-[#FFF] text-[42px] not-italic font-semibold leading-[42px] tracking-[-2.52px]'>{user?.experience_points} XP</p>
                </div>
                <p className='text-[#FAFAFA] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>
                    Use Time Credits (TC) to rent FrodoBots for missions and earn XP.
                </p>
                <p className='text-[#FAFAFA] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>
                    Complete missions to gain XP, and unlock more challenging and rewarding missions.
                </p>
            </div>
            <div className='flex flex-col items-start gap-[16px] self-stretch'>
                {/* <button className='flex w-full h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[32px] bg-[#25BD66]' onClick={buyLpHandler}>
                    <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                        Purchase More LP
                    </p>
                </button>
                <button className='flex w-full h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[32px] bg-[#25BD66]' onClick={buyTcHandler}>
                    <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                        Purchase TC
                    </p>
                </button> */}
                <button className='flex w-full h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[32px] bg-[#000]' onClick={() => { window.open(`https://shop.frodobots.com/`) }}>
                    <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                        Buy an EarthRover
                    </p>
                </button>
            </div>
        </div>
    )
}

export default LeftSection